import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { HrFlexContainer, HrTitleContainer, HrTitleH4 } from '@components/styles/hr-styles';
import { SectionLanguage } from './languaje';
import { DisplaySettingsContext } from '../../store/display-settings';

export const ControllerLanguage = observer(
  ({ vacancyRequirement, formState, control, postulant, action, getValues, setValue, unregister, vacancy }) => {
    const [t] = useTranslation();
    const requiredLanguage = vacancyRequirement.language === 1;
    const { darkMode,fontSizeSetting } = useContext(DisplaySettingsContext);

    return (
      <HrFlexContainer flexDirection='column' alignItems='flex-start'>
        {/* IDIOMAS */}
        <HrTitleContainer borderBottom={darkMode ? '1px solid #767676' : ''} >
          <HrTitleH4 fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''} isRequired={requiredLanguage}>{t('postulant.language.title')}</HrTitleH4>
        </HrTitleContainer>

        <SectionLanguage
          requiredLanguage={requiredLanguage}
          getValues={getValues}
          setValue={setValue}
          unregister={unregister}
          vacancy={vacancy}
          control={control}
          formState={formState}
          postulant={postulant}
          action={action}
        />
      </HrFlexContainer>
    );
  }
);
